export const notFoundStrings = {
  title: 'No encontramos esta página',
  description: 'Es posible que el enlace esté roto o que la página ya no exista.',
  errorBoundaryTitle: 'Algo salió mal',
  errorBoundaryDescription:
    'Ocurrió un error inesperado. Vuelve al inicio o intenta de nuevo más tarde.',
  goHome: 'Volver al inicio',
  goPatients: 'Ir a pacientes',
} as const
